export const STORAGE_KEYS = {
  /**
   * 【不要改回 `Authorization`】前端自己的認證 cookie 一律用 `xsenal_` 前綴。
   *
   * 過去這兩把用的是 `Authorization` / `RefreshToken`，與後端在 Google 登入時寫在
   * 父網域（`.momentx.ai`）上的 HttpOnly cookie **同名**。同名 cookie 會並存，
   * 瀏覽器兩份都送出，而 SSR 從 request header 解析時只取到第一筆——依 RFC 6265，
   * 同 path 下較早建立的排前面，也就是後端寫的那份舊 token 永遠贏。
   *
   * 後果：切換組織後前端只更新得了 host-only 那份，父網域那份原封不動，於是每次
   * 整頁重載都又讀回舊組織的 token，畫面是新組織、API 全讀到上一個組織的資料，
   * 而且**只有登出才會好**（`server/routes/_auth/logout.post.ts` 是唯一刪得掉
   * HttpOnly 父網域 cookie 的地方）。
   *
   * 改名之後前後端的 cookie 各走各的，同名相撞的整類問題從根上消失。
   */
  TOKEN: 'xsenal_token',
  REFRESH_TOKEN: 'xsenal_refresh_token',
  ORGUUID: 'ORGUUID',
  CSRF_TOKEN: 'CsrfToken',
  /**
   * Google 登入時由後端寫在父網域上的 cookie，前端不讀它，
   * 但登出時必須一起清掉（見 server/routes/_auth/logout.post.ts）。
   */
  MEMBER_INFO: 'memberinfo',
  REDIRECT_AFTER_LOGIN: 'redirect_after_login',
  QUICK_START_FORM_DATA: 'quickStartFormData',
  QUICK_START_ORDER_ID: 'quickStartOrderId',
} as const;

/**
 * 認證相關 cookie 的存活時間（7 天）。
 *
 * token / refresh token / ORGUUID 三者要用同一個值：ORGUUID 若是 session cookie，
 * 關掉瀏覽器再開就只剩 token，cookie 遷移那一步會因為讀不到目前組織而少掉 scope 驗證。
 */
export const AUTH_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;

/**
 * 前端改名前用的 cookie 名稱，同時也是後端寫在父網域上那兩份的名稱。
 *
 * 【這兩個名字不能只當成殘留看待】Google 登入的 token 是後端用這兩個名字寫進瀏覽器、
 * 再把人導回 `/auth/callback` 的，query 上沒有 token——也就是說，舊名稱同時還是那條
 * 流程唯一的交接管道。前端在平常的頁面上不讀它們，只在回調頁讀一次就銷毀
 * （見 `server/routes/_auth/oauth-handoff.post.ts`）。
 *
 * 除了交接那一次，其餘場合一律只清除：
 *   - host-only 那份是舊版前端留下的，留著只是佔位（`plugins/00.authCookieMigration.client.ts`
 *     會把值搬到新名稱後刪掉，讓既有使用者不必重新登入）
 *   - 父網域那份是後端寫的 HttpOnly，只有 server route 刪得掉（登出時、或交接完成時）
 */
export const LEGACY_AUTH_COOKIE_KEYS = {
  TOKEN: 'Authorization',
  REFRESH_TOKEN: 'RefreshToken',
} as const;
